import validatorResult from '@/directives/validator/common/result/validatorResult';

export default (severity = 'danger') => (value) => validatorResult(
  value !== null,
  {
    danger: 'Ett värde måste anges',
    warn: 'Ett värde rekommenderas',
  },
  severity,
);
